import React from 'react';
import ReactDOM from 'react-dom/client';
import { hotjar } from 'react-hotjar';
import App from './App';
import './assets/css/custom.css';
import reportWebVitals from './reportWebVitals';
// import Fudge from "@fudge-ai/browser"

// Fudge.init("0b8271cb-0f6e-4137-a648-69ca4fef2e5f")
import { initAmplitude } from './utilities/amplitude';

initAmplitude();
hotjar.initialize(process.env.REACT_APP_HOTJARID);

// react 18
ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
